/* Nav alignment override — runs after shop.js, replaces timber.alignMenu
   with a correct measurement-based overflow collapse that moves tail items
   into a right-anchored "More" dropdown. Loaded via theme.liquid. */
(function () {
  if (typeof window.jQuery === 'undefined') return;
  var $ = window.jQuery;
  if (typeof window.timber === 'undefined') return;

  timber.alignMenu = function () {
    var $nav = timber.cache && timber.cache.$navigation;
    if (!$nav || !$nav.length) return;

    // Mobile: leave markup alone; CSS handles stacked layout.
    if (window.innerWidth < timber.vars.bpLarge) {
      $nav.addClass('nav-initialized');
      return;
    }

    // Reset — return any items from a prior More menu to the nav, remove the stale trigger.
    var $moreList = $('#moreMenu--list');
    if ($moreList.length) {
      $moreList.children('li').appendTo($nav);
    }
    $('#moreMenu').remove();

    // Real available width = .site-nav's own box (it's width:100% inside the wrapper).
    var available = $nav[0].getBoundingClientRect().width;
    if (!available) {
      $nav.addClass('nav-initialized');
      return;
    }

    // Reserve for the More trigger (approximate rendered width).
    var MORE_RESERVED = 80;

    var $items = $nav.children('li').not('.large--hide, .customer-navlink');
    var widths = [];
    var total = 0;
    $items.each(function () {
      var w = this.getBoundingClientRect().width;
      widths.push(w);
      total += w;
    });

    // Fits natively — reveal and bail.
    if (total <= available) {
      $nav.addClass('nav-initialized');
      return;
    }

    // Otherwise pop tail items until remaining + More reserve fits.
    var tail = [];
    var remaining = total;
    for (var i = $items.length - 1; i >= 0 && remaining + MORE_RESERVED > available; i--) {
      tail.unshift($items.eq(i));
      remaining -= widths[i];
    }

    // Preserve outerHTML (dropdown children etc.) before detaching.
    var html = tail.map(function ($el) { return $el.prop('outerHTML'); }).join('');
    tail.forEach(function ($el) { $el.remove(); });

    if (html) {
      $nav.append(
        '<li id="moreMenu" class="site-nav--has-dropdown" aria-haspopup="true">'
          + '<a href="#" aria-haspopup="true">More'
          + '<span class="icon-fallback-text"><span class="icon icon-arrow-down" aria-hidden="true"></span></span>'
          + '</a>'
          + '<ul id="moreMenu--list" class="site-nav--dropdown">' + html + '</ul>'
        + '</li>'
      );
    }

    $nav.addClass('nav-initialized');
  };

  /* Fire alignMenu as soon as the nav exists — don't wait for shop.js's
     $(window).load(timber.responsiveNav) hook, which blocks on every image
     on the page (~1.4s of dead time on this theme). Fonts are the only thing
     that can shift link widths post-DOMContentLoaded, so re-measure on
     document.fonts.ready if fonts hadn't loaded yet. The original
     responsiveNav() still runs later and wires up the resize handler. */
  function runOnce() {
    if (!window.timber || !timber.cache || !timber.cache.$navigation || !timber.cache.$navigation.length) {
      return false;
    }
    timber.alignMenu();
    return true;
  }

  function bootstrap() {
    if (!runOnce()) {
      // timber.init hasn't populated cache yet — retry on next frame.
      requestAnimationFrame(bootstrap);
      return;
    }
    if (document.fonts && document.fonts.status !== 'loaded') {
      document.fonts.ready.then(function () {
        // Reset and re-measure with final font metrics.
        var $nav = timber.cache.$navigation;
        $nav.removeClass('nav-initialized');
        var $more = $('#moreMenu--list');
        if ($more.length) { $more.children('li').appendTo($nav); }
        $('#moreMenu').remove();
        timber.alignMenu();
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }
})();
